import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import FormikInput from "../../../Formik/FormikInput";
import FormikSelect from "../../../Formik/FormikSelect";
import styled from "styled-components";
import { useLanguage } from "../../../LangTranslation/LanguageContext";
import useListOptions from "../../../../CustomHooks/useListOptions";
import { onChangeSelectContact } from "../../../../DataApi/contacts/onchangeSelectContact";
import { useSession } from "../../../../authentications/SessionContext";
import { countryChangeDefaultValues } from "../../../../utilities/Validation Schema/onChangeDefaultOptions";
import { findAndAddOption } from "../../../../utilities/findAndAddOption";

const StyledLabel = styled.label`
  color: #535559;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
`;
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: #ff5837;
  }
`;

const Contact = ({ disabled, contactIncommingOptions }) => {
  const { sessionInfo } = useSession();
  const { company_id, context, user_id } = sessionInfo;
  const { setFieldValue, values } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];

  const {
    options: titleList,
    setOptions: setTitleList,
    handleCustomSearch,
  } = useListOptions();
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);

  const handleChangeCountry = async (
    option,
    { name },
    values,
    setFieldValue
  ) => {
    const response = await onChangeSelectContact({
      company_id,
      context,
      keyChange: name,
      values: { ...values, name: option.value },
      model: "res.partner",
      defaulChange: countryChangeDefaultValues,
    });
    findAndAddOption({
      availableOptions: countryList,
      incomingOption: [option.value, option.label],
      setAvailableOptions: setCountryList,
    });
    const incomingValues = response?.result?.value || {};
    Object.keys(incomingValues)?.forEach((key) => {
      setFieldValue(key, incomingValues[key]);
    });
    handleCustomSearch({
      model: "res.country.state",
      args: [["country_id", "=?", option.value]],
      setState: setStateList,
    });
  };
  useEffect(() => {
    Promise.all([
      handleCustomSearch({
        model: "res.country",
        setState: setCountryList,
      }),
      handleCustomSearch({
        model: "res.country.state",
        setState: setStateList,
      }),
      handleCustomSearch({
        model: "res.partner.title",
        setState: setTitleList,
      }),
    ]).then((response) => {
      try {
        setCountryList([
          ...response[0],
          ...(contactIncommingOptions?.country_id || []),
        ]);
        setStateList([
          ...response[1],
          ...(contactIncommingOptions?.state_id || []),
        ]);
        setTitleList([
          ...response[2],
          ...(contactIncommingOptions?.title || []),
        ]);
      } catch (error) {
        setCountryList([...response[0]]);
        setStateList([...response[1]]);
        setTitleList([...response[2]]);
      }
    });
  }, [contactIncommingOptions]);
  return (
    <div>
      <FormContainer className="row g-3 px-2">
        <div className="col-md-6">
          <StyledLabel
            htmlFor="inputPassword4"
            className="form-label"
            defaultValue=""
          >
            Title
          </StyledLabel>
          <FormikSelect disabled={disabled} name="title" options={titleList} />
        </div>
        <div className="col-md-6">
          <StyledLabel className="form-label" defaultValue="">
            Job Position
          </StyledLabel>
          <FormikInput name="function" disabled={disabled} />
        </div>

        <div className="col-md-4">
          <StyledLabel htmlFor="inputPassword4" className="form-label">
            {t["Phone"]}
          </StyledLabel>
          <FormikInput disabled={disabled} name="phone" />
        </div>
        <div className="col-md-4">
          <StyledLabel
            htmlFor="inputPassword4"
            className="form-label"
            defaultValue=""
          >
            {t["Mobile"]}
          </StyledLabel>
          <FormikInput disabled={disabled} name="mobile" />
        </div>
        <div className="col-md-4">
          <StyledLabel
            htmlFor="inputPassword4"
            className="form-label"
            defaultValue=""
          >
            {t["Email"]}
          </StyledLabel>
          <FormikInput disabled={disabled} type="email" name="email" />
        </div>
        {/* if type not contact */}
        {values.type !== "contact" && (
          <>
            <div className="col-md-4">
              <StyledLabel
                htmlFor="inputPassword4"
                className="form-label"
                defaultValue=""
              >
                {t["Country"]}
              </StyledLabel>
              <FormikSelect
                disabled={disabled}
                name="country_id"
                options={countryList}
                handleSearch={({ ...args }) =>
                  handleCustomSearch({
                    ...args,
                    model: "res.country",
                  })
                }
                onChange={(option, event) => {
                  setFieldValue("country", option);
                  handleChangeCountry(option, event, values, setFieldValue);
                }}
              />
            </div>
            <div className="col-md-4">
              <StyledLabel
                htmlFor="inputPassword4"
                className="form-label"
                defaultValue=""
              >
                {t["State"]}
              </StyledLabel>
              <FormikSelect
                disabled={disabled}
                name="state_id"
                handleSearch={({ ...args }) =>
                  handleCustomSearch({
                    ...args,
                    model: "res.country.state",
                    args: values.country_id
                      ? [["country_id", "=?", values.country_id]]
                      : [],
                  })
                }
                onChange={(option, event) => {
                  setFieldValue("state", option);
                }}
                options={stateList}
              />
            </div>
            <div className="col-md-4">
              <StyledLabel
                htmlFor="inputPassword4"
                className="form-label"
                defaultValue=""
              >
                {t["City"]}
              </StyledLabel>
              <FormikInput disabled={disabled} name="city" />
            </div>
            <div className="col-md-4">
              <StyledLabel
                htmlFor="inputPassword4"
                className="form-label"
                defaultValue=""
              >
                {t["Address"]}
              </StyledLabel>
              <FormikInput name="street" disabled={disabled} />
            </div>
            <div className="col-md-4 " style={{ marginTop: 48 }}>
              <FormikInput disabled={disabled} name="street2" />
            </div>
            <div className="col-md-4">
              <StyledLabel
                htmlFor="inputPassword4"
                className="form-label"
                defaultValue=""
              >
                {t["Zip"]}
              </StyledLabel>
              <FormikInput disabled={disabled} name="zip" />
            </div>
          </>
        )}
        <div className="col-md-12">
          <StyledLabel className="form-label" defaultValue="">
            {t["Notes"]}
          </StyledLabel>
          <FormikInput
            disabled={disabled}
            style={{
              display: "block",

              height: "130px",
            }}
            textArea
            name="comment"
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default Contact;
